import React, { useEffect, useState } from "react";
import { rootReducersState } from "../../reducers";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ConfirmDialog,
  EmployHERName,
  FlashMessage,
  Input,
  Modal,
} from "../../components/common";
import _ from "lodash";
import candidateServices from "../../services/candidate.services";
import { sessionOutRequest } from "../../reducers/auth/session.reducer";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { FormControlLabel } from "@material-ui/core";
import { ReactComponent as InfoPinkIcon } from "../../assets/svg/info-pink-icon.svg";
import { ReactComponent as AlertPinkIcon } from "../../assets/svg/alert-pink-icon.svg";


const deactivateReasonsList = [
  "I need a break from employHER",
  "There is a privacy concern for me",
  "There is a safety concern for me",
];
const deleteReasonsList = [
  "I have a duplicate account on employHER",
  "There is a privacy and safety concern for me",
  "I’m receiving unwanted contact",
];

const AccountPreferences = () => {
  const dispatch = useDispatch();
  const [showDeactivateModal, setShowDeactivateModal] =
    useState<boolean>(false);
  const [deactivateConfirmModal, setDeactivateConfirmModal] =
    useState<boolean>(false);
  const [deactivateReasonStatus, setDeactivateReasonStatus] =
    useState<string>("0");
  const [deactivateReason, setDeactivateReason] = useState<string>("");
  const [deactivateReasons, setDeactivateReasons] = useState<Array<string>>([]);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState<boolean>(false);
  const [deleteReasonStatus, setDeleteReasonStatus] = useState<string>("0");
  const [deleteReason, setDeleteReason] = useState<string>("");
  const [deleteReasons, setDeleteReasons] = useState<Array<string>>([]);
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session.currentUser
  );

  useEffect(() => {
    setDeactivateReasons(deactivateReasonsList);
    setDeleteReasons(deleteReasonsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDeactivateCancel = () => {
    setDeactivateReason("");
    setShowDeactivateModal(false);
  };

  const handleDeleteCancel = () => {
    setDeleteReason("");
    setShowDeleteModal(false);
  };

  const handleConfirmDeactivate = () => {
    setDeactivateConfirmModal(true);
  };

  const handleConfirmDelete = () => {
    setDeleteConfirmModal(true);
  };

  const handleDeactivate = async () => {
    let reason = deactivateReasons[parseInt(deactivateReasonStatus)];

    if (reason === undefined) {
      reason = deactivateReason;
    }

    try {
      const result = await candidateServices.deactivateAccount({
        reason,
      });

      if (result.flag) {
        dispatch(sessionOutRequest());
      } else {
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage(error?.message, "error");
    }
  };

  const handleDelete = async () => {
    let reason = deleteReasons[parseInt(deleteReasonStatus)];

    if (reason === undefined) {
      reason = deleteReason;
    }

    try {
      const result = await candidateServices.deleteAccount({
        reason,
      });

      if (result.flag) {
        dispatch(sessionOutRequest());
      } else {
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage(error?.message, "error");
    }
  };

  return (
    <>
      <div className="profile-container">
        <div>
          <div className="settings-header">
            <h3>Account Preferences</h3>
            <p className="font-md">Control settings related to your account.</p>
          </div>
          <div className="account-preferences-wrapper pt-0">
            <div className="settings-header">
              <h3>Deactivate Account</h3>
              <p className="font-md">
                If you wish to take a break from <EmployHERName />, you can deactivate your account.
              </p>
              <p className="font-md">In this case, you will have no access to your account and will not be able to participate in any activities.</p>
              <p className="font-md">In addition, almost everything you've shared will be removed from your profile.</p>
            </div>

            <div className="delete-account-info">
              <div className="info-icon">
                <InfoPinkIcon />
              </div>
              <p className="font-md">
                Your profile, post, connections and message will be hidden until you reactivate your account by logging in again.
              </p>
            </div>
            <div className="action-btn-wrapper">
              <Button
                variant="contained"
                onClick={() => setShowDeactivateModal(true)}
              >
                Deactivate Account
              </Button>
            </div>
          </div>
          <hr />
          <div className="account-preferences-wrapper">
            <div className="settings-header">
              <h3>Delete Account</h3>
              <p className="font-md">
                Your <EmployHERName /> account will be deleted once you delete
                it.
              </p>
              <p className="font-md">
                You can't get back any connection or information that you shared on <EmployHERName /> after you delete it.
              </p>
              <p className="font-md">
                You will also lose your connections and all of your messages.
              </p>
            </div>
            <div className="delete-account-info">
              <div className="info-icon">
                <AlertPinkIcon />
              </div>
              <p className="font-md">
                This action is permanent and cannot be undone. All your data will be permanently deleted.
              </p>
            </div>
            <div className="action-btn-wrapper">
              <Button
                variant="contained"
                onClick={() => setShowDeleteModal(true)}
              >
                Delete Account
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal
          visible={showDeactivateModal}
          closeButton={true}
          title="Deactivate Account"
          onClose={() => setShowDeactivateModal(false)}
        >
          <p className="pb-12 font-md font-bold-600">Reason to deactivate account</p>
          <div>
            <RadioGroup
              value={deactivateReasonStatus}
              onChange={(e: React.ChangeEvent<any>) => {
                setDeactivateReasonStatus(_.get(e, "target.value", ""));
              }}
            >
              <FormControlLabel
                value="0"
                control={<Radio />}
                label="I need a break from employHER"
              />
              <FormControlLabel
                value="1"
                control={<Radio />}
                label="There is a privacy concern for me"
              />
              <FormControlLabel
                value="2"
                control={<Radio />}
                label="There is a safety concern for me"
              />
              <FormControlLabel value="3" control={<Radio />} label="Other" />
            </RadioGroup>

            <div className="mt-12">
            <Input
              name="reason"
              className="reason-text"
              placeholder="Add your custom reason to deactivate account"
              onChange={(e) => {
                setDeactivateReason(e.target.value);
              }}
            />
            </div>
          </div>
          <div className="btn-deactivate">
            <Button
              variant="outlined"
              onClick={() => handleDeactivateCancel()}
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleConfirmDeactivate()}
            >
              Continue
            </Button>
          </div>
        </Modal>
        <ConfirmDialog
          visible={deactivateConfirmModal}
          title="Deactivate Account"
          onCancel={() => setDeactivateConfirmModal(false)}
          onConfirm={() => handleDeactivate()}
        >
          <p className="pb-12 text-center">
            <strong>
              {_.get(sessionReducer, "first_name", "")}{" "}
              {_.get(sessionReducer, "last_name", "")}
            </strong>
            , Hope to see you soon on <EmployHERName />.
          </p>
          <p className="text-center">
            <span>
              Once you <span className="span-link">Deactivate</span> your
              account, you will loose the visibility on <EmployHERName />.
            </span>
          </p>
        </ConfirmDialog>
        <Modal
          visible={showDeleteModal}
          closeButton={true}
          title="Delete Account"
          onClose={() => setShowDeleteModal(false)}
        >
          <p className="pb-12 font-md font-bold-600">Reason to delete account</p>
          <div>
            <RadioGroup
              value={deleteReasonStatus}
              onChange={(e: React.ChangeEvent<any>) => {
                setDeleteReasonStatus(_.get(e, "target.value", ""));
              }}
            >
              <FormControlLabel
                value="0"
                control={<Radio />}
                label="I have a duplicate account on employHER"
              />
              <FormControlLabel
                value="1"
                control={<Radio />}
                label="There is a privacy and safety concern for me"
              />
              <FormControlLabel
                value="2"
                control={<Radio />}
                label="I’m receiving unwanted contact"
              />
              <FormControlLabel value="3" control={<Radio />} label="Other" />
            </RadioGroup>
            <div className="mt-12">
            <Input
              name="reason"
              className="reason-text"
              placeholder="Add your custom reason to delete account"
              onChange={(e) => {
                setDeleteReason(e.target.value);
              }}
            />
            </div>
          </div>
          <div className="btn-deactivate">
            <Button
              variant="outlined"
              onClick={() => handleDeleteCancel()}
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleConfirmDelete()}
            >
              Continue
            </Button>
          </div>
        </Modal>
        <ConfirmDialog
          visible={deleteConfirmModal}
          onCancel={() => setDeleteConfirmModal(false)}
          onConfirm={() => handleDelete()}
          title="Delete Account"
        >
          <p className="text-center pb-12">
            {_.get(sessionReducer, "first_name", "")}{" "}
            {_.get(sessionReducer, "last_name", "")}, Hope to see you soon{" "}
            on <EmployHERName />.
          </p>
          <p className="text-center">
            Are you sure you want to{" "}
            <span className="title">Delete Account</span>?
          </p>


        </ConfirmDialog>
      </div>
    </>
  );
};

export default AccountPreferences;
